import { Injectable, inject } from '@angular/core';
import { ColorDotColor, ValidationResult } from '@oe-backend/types';
import { ResponseObjectApiInterface } from 'src/app/types/interfaces/api-responses/response-object.api.interface';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../../base-api/base-api.service';
import { Observable } from 'rxjs';

export interface Color {
	name: string;
	colorCode: string;
	isPreselected: boolean;
}

@Injectable({ providedIn: 'root' })
export class PersonalizationService extends BaseApiService {
	private http = inject(HttpClient);

	fetchColors(): Observable<Color[]> {
		return this.http
			.get<
				ResponseObjectApiInterface<ColorDotColor[]>
			>(`${this.apiBaseUrl}/Personalization/GetPossibleColors`)
			.pipe(
				map((response: ResponseObjectApiInterface<ColorDotColor[]>) => {
					return response.data.map((color) => {
						return {
							name: color.name!,
							colorCode: color.colorCode!,
							isPreselected: color.isPreselected!,
						};
					});
				}),
			);
	}

	validatedEngravingText(text: string) {
		return this.http
			.get<
				ResponseObjectApiInterface<ValidationResult>
			>(`${this.apiBaseUrl}/Personalization/validate?text=${text}`)
			.pipe(
				map((response: ResponseObjectApiInterface<ValidationResult>) => {
					return response.data;
				}),
			);
	}
}
